/**
 * Shared report layout metrics.
 *
 * Designer (react-grid-layout) and Viewer (CSS Grid) use the same row
 * size and gap so the canvas is WYSIWYG with the live dashboard.
 */

/** Grid column count (designer RGL + viewer CSS grid). */
export const REPORT_COLS = 12;

/** Shared row unit (px). Designer RGL rowHeight and viewer CSS grid track. */
export const VIEWER_ROW_PX = 72;

/** Designer react-grid-layout rowHeight (px) — same as the viewer. */
export const DESIGNER_ROW_HEIGHT = VIEWER_ROW_PX;

/** Viewer CSS grid gap (px). */
export const VIEWER_GAP = 16;

/** Designer RGL margin [x, y] (px) — matches viewer gap. */
export const DESIGNER_MARGIN = [VIEWER_GAP, VIEWER_GAP];

/** Designer RGL container padding [x, y] (px). */
export const DESIGNER_CONTAINER_PADDING = [0, 0];

/** Designer minimum widget width in columns. */
export const DESIGNER_MIN_W = 2;

/** Designer minimum widget height in rows. */
export const DESIGNER_MIN_H = 2;

/** Approximate designer pixel height for an `h` value (ignores RGL margins). */
export function designerApproxHeightPx(h) {
  return Math.max(1, Number(h) || 1) * DESIGNER_ROW_HEIGHT;
}

/** Viewer minHeight for an `h` value. */
export function viewerMinHeightPx(h) {
  return Math.max(1, Number(h) || 1) * VIEWER_ROW_PX;
}
